import { ROUTES_APPLICATION_PATH } from "../../../../routes.constants";
import { USER_ROLES } from "../../../../components/components.constants";
import { TENANT_CLASS } from "../../../../config/tenant.class.config";

import { getFashionRetailNavigationOptions } from "./fashionRetail.helpers"
import { getSupermarketNavigationOptions } from './supermarket.helpers'
import { getIndustryNavigationOptions } from './industry.helpers'
import { getGasStationNavigationOptions } from './gasStation.helpers'

import { buildMenu, SECTION_LABELS } from './utils'

// dados de integração somente em homologação
const options  = {
  hasDataIntegration: false
}

// menus

// analytics e home somente em homologação
const getAldoNavigationOptions = (t, tenantContext, options) =>
  getFashionRetailNavigationOptions(t, tenantContext, {
    hasInventoryQuality: false,
    hasOwnHome: false,  
    // dataItems: [
    //   { pageName: "Analytics", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6], icon: "barChart" },
    // ],    
  }, 

  options
);

// home, analytcs, otb e plano de compra somente em homologação
const getBesniNavigationOptions = (t, tenantContext, options) =>
  getFashionRetailNavigationOptions(t, tenantContext, {
    hasOwnHome: false,
    hasOtb: false,
    hasPurchasePlan: false,
    hasPlanning: false,    
    // dataItems: [
    //   { pageName: "Analytics", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6], icon: "barChart" },
    // ],
  },
  options
);  

// analytics, home e plano de compra somente em homologação
const getCaeduNavigationOptions = (t, tenantContext, options) =>
  getFashionRetailNavigationOptions(t, tenantContext, {
    hasOtb: false,
    hasPurchasePlan: false,
    hasPlanning: false,
    hasOwnHome: false,
    // dataItems: [
    //   { pageName: "Analytics", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6], icon: "barChart" },
    // ],    
  },
  options
);

// analytics e home somente em homologação.
const getGrazziotinNavigationOptions = (t, tenantContext, options) =>
  getFashionRetailNavigationOptions(t, tenantContext, {
    hasInventoryQuality: false,
    hasOwnHome: false,
    // dataItems: [
    //   { pageName: "Analytics", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6], icon: "barChart" },
    // ],    
  },
  options
);

// analytics e home somente em homologação.
const getMonjuaNavigationOptions = (t, tenantContext, options) =>
  getFashionRetailNavigationOptions(t, tenantContext, {
    hasInventoryQuality: false,
    hasOwnHome: false,
    opportunityItems: [
      {
        pageName: "Oportunidades",
        route: ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[0],
        icon: "lightbulb",
      },
      {
        pageName: "Checkout de Oportunidades",
        route: ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[1],
        icon: "lightbulb",        
      }
    ],
    // dataItems: [
    //   { pageName: "Analytics", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6], icon: "barChart" },
    // ],     
  },
  options
);

const getDemoNavigationOptions = (t, tenantContext, userRole, options) => {
  const {
    hasAssortmentManagement = false,
    hasPlanvsforecastAnalysis = false,
    hasForecastAssertivity = false, // ver TODO (ponto 1)
    hasProductOpportunities = false,
    hasOpportunityCheckout = false, // ver TODO (ponto 2)
  } = tenantContext;

  // NOTA: no modelo unificado anterior, o tenant "demo" mostrava todos os itens de
  // todas as classes, inclusive desabilitados, como preview completo do menu. Essa
  // migração ainda não reproduz esse comportamento — por ora o Demo só replica os
  // itens que ele já tinha ativos antes.

  const home = {
    menuName: "Home",
    route: ROUTES_APPLICATION_PATH.HOME.BASE_URL,
    icon: "home",
  };

  const plano = buildMenu({
    menuName: "Plano",
    route: ROUTES_APPLICATION_PATH.ANALYSIS.BASE_URL,
    icon: "plano",
    sectionDefs: [
      { label: SECTION_LABELS.OPPORTUNITIES, items: [] },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: [
          hasPlanvsforecastAnalysis && {
            pageName: t("productPlanVsForecast"),
            route: ROUTES_APPLICATION_PATH.ANALYSIS.COMPONENT_URL[0],
            icon: "sitemap",
          },
          // TODO (ponto 1): hasForecastAssertivity && { ... }
        ],
      },
      { label: SECTION_LABELS.DATA, items: [] },
    ],
    options
  });

  const produto = buildMenu({
    menuName: "Produto",
    route: ROUTES_APPLICATION_PATH.PRODUCTS.BASE_URL,
    icon: "produto",
    sectionDefs: [
      {
        label: SECTION_LABELS.OPPORTUNITIES,
        items: [
          hasProductOpportunities && {
            pageName: t("productOpportunities"),
            route: ROUTES_APPLICATION_PATH.OPPORTUNITIES.COMPONENT_URL[0],
            icon: "lightbulb",
          },
          // TODO (ponto 2): hasOpportunityCheckout && { ... }
        ],
      },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: [
          { pageName: "Ajuste de OTB", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[1], icon: "box" },
          { pageName: "Qualidade de Estoque", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[2], icon: "shield" },
          { pageName: "Planejamento", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[3], icon: "sitemap" },
          { pageName: t("openOrders"), route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[0], icon: "cart" },
          { pageName: t("ordersHystory"), route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[1], icon: "cart" },
          (userRole !== USER_ROLES.SHOPKEEPER) && {
            pageName: t("purchaseParam"),
            route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[2],
            icon: "cart",
          },
        ],
      },
      {
        label: SECTION_LABELS.DATA,
        items: [
          { pageName: "Análise de Performance", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[0], icon: "barChart" },
          { pageName: "Performance de Produto", route: ROUTES_APPLICATION_PATH.PRODUCTS.COMPONENT_URL[6], icon: "barChart" },
        ],
      },
    ],
    options
  });

  const sortimento = buildMenu({
    menuName: "Sortimento",
    route: ROUTES_APPLICATION_PATH.SORTIMENTO.BASE_URL,
    icon: "sortimento",
    sectionDefs: [
      { label: SECTION_LABELS.OPPORTUNITIES, items: [] },
      {
        label: SECTION_LABELS.TRANSACTIONAL,
        items: [
          hasAssortmentManagement && {
            pageName: "Sortimento",
            route: ROUTES_APPLICATION_PATH.ACTIONS.COMPONENT_URL[3],
            icon: "folder",
          },
        ],
      },
      { label: SECTION_LABELS.DATA, items: [] },
    ],
    options
  });

  return [home, plano, produto, sortimento].filter(Boolean);
};

export const getNavigationOptionsByTenanat = (tenant, t, tenantContext, userRole = undefined) => {
  const tenantLower = tenant.toLowerCase();

  if (tenantContext?.tenantClass === TENANT_CLASS.FASHION_RETAIL) {
    if (tenantLower === 'aldo') return getAldoNavigationOptions(t, tenantContext, options);
    if (tenantLower === 'besni') return getBesniNavigationOptions(t, tenantContext, options);
    if (tenantLower === 'caedu') return getCaeduNavigationOptions(t, tenantContext, options);
    if (tenantLower === 'grazziotin') return getGrazziotinNavigationOptions(t, tenantContext, options);
    if (tenantLower === 'monjua') return getMonjuaNavigationOptions(t, tenantContext, options);

    return getFashionRetailNavigationOptions(t, tenantContext, {}, options);
  }

  if (tenantContext?.tenantClass === TENANT_CLASS.SUPERMARKET) {  
    return getSupermarketNavigationOptions(t, tenantContext, {}, options);
  }

  if (tenantContext?.tenantClass === TENANT_CLASS.GAS_STATION) {  
    return getGasStationNavigationOptions(t, tenantContext, userRole, options);
  }  

  if (tenantContext?.tenantClass === TENANT_CLASS.INDUSTRY) {  
    return getIndustryNavigationOptions(
      t, 
      tenantContext, 
      userRole, 
      {}, 
      { hasDataIntegration: false }
    );
  }  

  const menuStrategies = {
    'demo': () => getDemoNavigationOptions(t, tenantContext, userRole, options),
  };

  const getMenu = menuStrategies[tenantLower] || menuStrategies['demo'];
  return getMenu();
};